import { Locale } from '@cars4ever/public-ui';

export interface IOwnerTaxConfig {
  isIncluded: boolean;
}

const ownerTaxConfigMap: Record<Locale, IOwnerTaxConfig> = {
  [Locale.DK]: {
    isIncluded: true,
  },
  [Locale.SE]: {
    isIncluded: false,
  },
};

export default ownerTaxConfigMap;
